import styled from 'styled-components';
import ReactPaginate from 'react-paginate';
import { useRouter } from 'next/router';
import Arrow from './Arrow';
import LeftIcon from '../../../../../new-components/svg-icons/LeftIcon';
import RightIcon from '../../../../../new-components/svg-icons/RightIcon';
import { logEvent } from '../../../../../new-lib/analytics';

interface paginationPresentationProps {
  handlePageClick: any;
  appliedPageNumber: number | undefined;
  totalResultsDisplayed: number;
  cardsPerPage?: number | 12;
  pageRangeDisplayed?: number | 8;
}
const PaginationPresentation = ({
  handlePageClick,
  appliedPageNumber,
  totalResultsDisplayed,
  cardsPerPage,
  pageRangeDisplayed
}: paginationPresentationProps) => {
  const { locale } = useRouter();
  const numberOfPages = Math.ceil(
    totalResultsDisplayed / (cardsPerPage ? cardsPerPage : 12)
  );
  return (
    <Container numberOfPages={numberOfPages} className="pagination-container">
      <ReactPaginate
        onPageChange={event => {
          logEvent.click(`pagination_click`, 'PageNumberSelection', 'other', {
            page_no: event.selected + 1
          });
          handlePageClick(event);
        }}
        ariaLabelBuilder={(page, selectedPage) => `${page}, ${selectedPage}`}
        marginPagesDisplayed={0}
        pageRangeDisplayed={pageRangeDisplayed ? pageRangeDisplayed : 8}
        breakLabel={''}
        forcePage={appliedPageNumber ? appliedPageNumber - 1 : 0}
        pageCount={numberOfPages}
        renderOnZeroPageCount={null!}
        className="pagination"
        pageClassName="pagination-list"
        previousClassName="previous-arrow pagination-list"
        nextClassName="next-arrow pagination-list"
        previousLabel={
          locale == 'en' ? (
            <Arrow icon={<LeftIcon />} word="Prev" />
          ) : (
            <Arrow icon={<RightIcon />} word="Prev" />
          )
        }
        nextLabel={
          locale == 'en' ? (
            <Arrow icon={<RightIcon />} word="Next" />
          ) : (
            <Arrow icon={<LeftIcon />} word="Next" />
          )
        }
      />
    </Container>
  );
};
const Container = styled.div<any>`
  padding: 40px 0px 0px ;
  display: ${props => (props.numberOfPages < 2 ? 'none' : 'block')};
  .pagination {
    align-self: flex-end;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .pagination-list {
      width: 35px;
      height: 35px;
      font-family: materialMedium;
      font-size: 14px;
      text-align: center;
      color: ${props => props.theme.light.colors.black};
      background-color: #ffffff;
      border-radius: 5px;
      margin-inline-end: 8px;
      a {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      &:hover {
        background-color: #dff0fd;
      }
    }
    .selected {
      background-color: ${props =>
        props.theme.light.colors.primaryBlue} !important;
      color: #f3faff !important;
      &:hover {
        background-color: #3494d5 !important;
      }
    }

    .word {
      color: ${props => props.theme.light.colors.black};
    }
    .paginationarrow {
      color: #0179cb;
      gap: 8px;
    }
    .previous-arrow {
      font-size: 25px !important;
      background-color: unset !important;
      padding: 0px 25px;
      .paginationarrow {
        color: #0179cb;
      }
    }
    .next-arrow {
      font-size: 25px !important;
      background-color: unset !important;
      padding: 0px 25px;
    }
    .disabled {
      .paginationarrow {
        color: #acacaf !important;
      }
    }
  }
`;
export default PaginationPresentation;
